import { z } from 'zod';
import { patternShape } from './_shared';

export const session_started = patternShape.extend({
  pattern_anon_id: z.string(),
}).strict();

export const session_paused = z.object({
  pattern_anon_id: z.string(),
  elapsed_ms: z.number().int().nonnegative(),
  rows_advanced_so_far: z.number().int().nonnegative(),
}).strict();

export const session_resumed = z.object({
  pattern_anon_id: z.string(),
}).strict();

export const session_resumed_from_history = z.object({
  pattern_anon_id: z.string(),
  days_since_last_event: z.number().int().nonnegative(),
}).strict();

export const session_completed = z.object({
  pattern_anon_id: z.string(),
  total_duration_ms: z.number().int().nonnegative(),
  active_duration_ms: z.number().int().nonnegative(),
  rows_advanced: z.number().int().nonnegative(),
  pause_count: z.number().int().nonnegative(),
  prev_row_count: z.number().int().nonnegative(),
  expand_node_count: z.number().int().nonnegative(),
}).strict();
